import { Outlet, useParams } from "react-router-dom";
import { isLocalePrefix } from "../../utils/localePaths";
import { NotFoundPage } from "../shared/NotFoundPage";

export const LocaleOutlet = () => {
  const { locale } = useParams();

  if (!isLocalePrefix(locale)) {
    return <NotFoundPage />;
  }

  return <Outlet />;
};
